import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import "./Breeds.css";
import Top_Navbar from "../../DashBaord/Top_navbar";

function Promotions(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

Promotions.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function BasicTabs() {

  /*********************************************************
   *  This function is load when page load and with dependency update
   *********************************************************/
  useEffect(() => {
    document.title = `Chiratae Super Admin || Email Templates List`;
  }, []);

  return (
    <>
      <Top_Navbar title={`Email Templates`}></Top_Navbar>
      <div class="iframe-container">
      	<iframe src="https://chiratae.primeapps.co.in/apiv3/templateeditor/" allowFullScreen ></iframe>
      </div>
    </>
  );
}
